export const isAppPath = (path: string) =>
  path.startsWith("/") && !path.startsWith("//") && !path.includes("\\");

/**
 * The web form runs on another origin, so it needs an absolute url back into
 * the app. Anything that is not a path inside the app returns to its root.
 */
export const buildReturnUrl = (
  path: string,
  appUrl: string = import.meta.env.VITE_APP_V2_URL
) => {
  const base = appUrl.replace(/\/$/, "");
  return isAppPath(path) && path !== "/" ? `${base}${path}` : base;
};
